import React, { useState } from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import axios from "../../utils/axiosConfig";
import { useUser } from "../../context/UserContext";
import RegistrationSurvey from "../questionary/RegistrationSurvey.js";
import "../../styles/features/events/EventDetails.css";


const PARTY_CONFIG = {
  dinner: {
    eventFormat: "DINNER",
    title: "Kolacja w kameralnym gronie",
    subtitle:
      "Kameralne spotkanie przy wspólnym stole, stworzone po to, żeby poznawać nowych ludzi w swobodnej atmosferze.",
    image: "/imagesEvents/dinner1.jpg",
  },

  wine: {
    eventFormat: "WINE_MEETING",
    title: "Spotkanie przy winie",
    subtitle:
      "Luźny wieczór przy winie, rozmowach i poznawaniu nowych osób bez presji.",
    image: "/images/party4.jpg",
  },

  social: {
    eventFormat: "SOMEET_SOCIAL",
    title: "Someet Social",
    subtitle:
      "Większe, swobodne spotkanie z muzyką i przestrzenią do poznawania nowych osób.",
    image: "/images/party2.jpg",
  },
};


const CITIES = [
  "Warszawa",
  "Kraków",
  "Wrocław",
  "Poznań",
  "Gdańsk",
  "Lublin",
];


export default function PartyEventDetails() {
  const navigate = useNavigate();
  const { partyCategory } = useParams();

  const {
    isAuthenticated,
    loginWithRedirect,
    getAccessTokenSilently,
  } = useAuth0();

  const {
    user,
    profileLoading,
    profileLoaded,
  } = useUser();

  const config = PARTY_CONFIG[partyCategory];
  const [interestId, setInterestId] = useState(null);

  const [showRegistrationSurvey, setShowRegistrationSurvey] =
    useState(false);
    
  const [selectedCity, setSelectedCity] =
    useState("");

  const [joining, setJoining] =
    useState(false);

  const [registered, setRegistered] =
    useState(false);

  const [joinMessage, setJoinMessage] =
    useState("");


  if (!config) {
    return (
      <div className="eventDetails page">
        <div className="eventDetails__container">
          <h2>
            Nie znaleziono tego rodzaju spotkania.
          </h2>

          <button
            className="eventDetails__back"
            onClick={() =>
              navigate("/events/party")
            }
          >
            ← Wróć
          </button>
        </div>
      </div>
    );
  }


  const handleJoin = async () => {
    if (!selectedCity || joining || registered) {
      return;
    }

    if (!isAuthenticated) {
      await loginWithRedirect({
        appState: {
          returnTo:
            `/events/party/${partyCategory}`,
        },
      });

      return;
    }

    if (profileLoading || !profileLoaded) {
      return;
    }

    if (!user?.profileCompleted) {
      navigate("/onboarding", {
        state: {
          from:
            `/events/party/${partyCategory}`,
        },
      });

      return;
    }

    try {
      setJoining(true);
      setJoinMessage("");

      const token =
        await getAccessTokenSilently({
          authorizationParams: {
            audience:
              "https://someet-api",
          },
        });

        const response = await axios.post(
          "/api/event-interests",
          {
            eventFormat: config.eventFormat,
            city: selectedCity,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const { interestId, created } = response.data;

        setInterestId(interestId);
        setRegistered(true);
      if (created) {
      setJoinMessage(
        "Jesteś na liście! 🤍 Gdy zbierzemy odpowiednią grupę, wyślemy Ci zaproszenie z terminem, miejscem i wszystkimi szczegółami."
      );
        setShowRegistrationSurvey(true);
        return;
      }

      setShowRegistrationSurvey(false);
      setJoinMessage(
        "Jesteś już na liście dla tego spotkania w tym mieście ✓"
      );

    } catch (error) {
      setJoinMessage(
        error.response?.data?.message ||
          "Nie udało się zapisać na listę. Spróbuj ponownie."
      );
    } finally {
      setJoining(false);
    }
  };


  return (
    <div className="eventDetails page">
      <div className="eventDetails__container">

        <div className="eventDetails__top">
          <button
            className="eventDetails__back"
            onClick={() =>
              navigate("/events/party")
            }
          >
            ← Spotkania
          </button>

          <div className="eventDetails__typeBadge">
            Spotkanie
          </div>
        </div>


        <div className="eventDetails__grid">

          {/* LEWA STRONA */}
          <div className="eventDetails__left">

            <div className="eventDetails__gallery">
              <div className="eventDetails__mainImgWrap">
                <img
                  className="eventDetails__mainImg"
                  src={config.image}
                  alt={config.title}
                />
              </div>
            </div>


            <div className="eventDetails__header">

              <h1 className="eventDetails__title">
                {config.title}
              </h1>

              <p className="eventDetails__subtitle">
                {config.subtitle}
              </p>

              <div className="eventDetails__metaRow">
                <span className="pill">
                  📍 Wybierz swoje miasto
                </span>

                <span className="pill">
                  💌 Zaproszenie po zebraniu grupy
                </span>
              </div>

            </div>

          <section className="eventDetails__section">
            <h3>Jak to działa?</h3>

            <p className="eventDetails__text">
              Zapisz się na listę zainteresowanych w wybranym mieście.
              Kiedy zbierzemy odpowiednią grupę, otrzymasz od nas
              propozycję terminu, miejsca i wszystkie szczegóły spotkania.
            </p>

            <p className="eventDetails__text">
              Zapis na listę jest bezpłatny i do niczego Cię nie zobowiązuje.
            </p>

            <p className="eventDetails__text">
              Zachęcamy też do wypełnienia ankiety na swoim profilu.
              Dzięki niej możemy lepiej poznać Twoje preferencje
              i tworzyć grupy, w których łatwiej będzie Ci znaleźć
              osoby o podobnych zainteresowaniach i stylu życia.
            </p>
          </section>

          <button
          type="button"
          className="btn btn-outline"
          onClick={() => navigate("/survey")}
        >
          Wypełnij ankietę
        </button>

          </div>


          {/* PRAWA STRONA */}
          <aside className="eventDetails__right">

            <div className="eventDetails__card">

              <h3 className="partyBooking__title">
                Dołącz do listy zainteresowanych
              </h3>

              <p className="eventDetails__note">
                Wybierz miasto, w którym chcesz
                wziąć udział w spotkaniu.
              </p>


              <div className="partyBooking__field">

                <label
                  htmlFor="party-city"
                  className="partyBooking__label"
                >
                  Miasto
                </label>

                <select
                  id="party-city"
                  className="partyBooking__select"
                  value={selectedCity}
                  onChange={(event) => {
                    setSelectedCity(
                      event.target.value
                    );

                    setRegistered(false);
                    setJoinMessage("");
                  }}
                >

                  <option value="">
                    Wybierz miasto
                  </option>

                  {CITIES.map((city) => (
                    <option
                      key={city}
                      value={city}
                    >
                      {city}
                    </option>
                  ))}

                </select>

              </div>


              <button
                type="button"
                className={`eventDetails__cta ${
                  !selectedCity ||
                  registered
                    ? "isDisabled"
                    : ""
                }`}
                onClick={handleJoin}
                disabled={
                  !selectedCity ||
                  joining ||
                  registered
                }
              >
                {registered
                  ? "Jesteś na liście ✓"
                  : joining
                    ? "Zapisywanie..."
                    : "Zapisz mnie"}
              </button>


              {joinMessage && (
                <p className="eventDetails__message">
                  {joinMessage}
                </p>
              )}

            </div>

          </aside>
          {showRegistrationSurvey && interestId && (
            <div
              className="registrationSurveyModal__overlay"
              onClick={() =>
                setShowRegistrationSurvey(false)
              }
            >
              <div
                className="registrationSurveyModal"
                onClick={(event) =>
                  event.stopPropagation()
                }
              >
                <button
                  type="button"
                  className="registrationSurveyModal__close"
                  onClick={() =>
                    setShowRegistrationSurvey(false)
                  }
                  aria-label="Zamknij"
                >
                  ×
                </button>

                <RegistrationSurvey
                  interestId={interestId}
                  onFinished={() =>
                    setShowRegistrationSurvey(false)
                  }
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}